const signupConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('signup', {
      url: '/signup',
      template: '<app-signup></app-signup>',
      access: {
        loginRequired: false,
      },
      resolve: {
        // used to set the page title
        $title: () => 'Signup',
      },
    });
};

export default signupConfig;



// WEBPACK FOOTER //
// ./src/modules/signup/signup.config.js